<template>
	<div>
		<div class="table-wrapper">
			<table class="table">
				<thead>
					<tr>
						<th v-if="on_select !== undefined" @click="select_all(is_dropped)" class="pointered" style="width: 30px;">
							<i v-if="list.length == selected.length" class="far fa-fw fa-eye"></i>
							<i v-if="list.length != selected.length" class="far fa-fw fa-eye-slash"></i>
						</th>
						<th>Mapa</th>
						<th v-for="(header, idx) in headers" :key="idx">{{ header }}</th>
						<th v-if="!is_dropped && select_driver">Motorista</th>
						<th v-if="!is_dropped && has_options">Opções</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="loading">
						<td :colspan="colspan" style="text-align: center;">
							<b><i class="fa fa-circle-notch fa-spin"></i> CARREGANDO INFORMAÇÕES...</b>
						</td>
					</tr>
					<tr v-if="!loading && list.length == 0 && list2.length == 0">
						<td :colspan="colspan" style="text-align: center;">
							<b>NENHUMA ENCONTRADA</b>
						</td>
					</tr>
					<tr v-for="(item, index) in list" :key="'register_' + index">
						<td v-if="on_select !== undefined" class="pointered" @click="on_select(item, index, is_dropped)">
							<i v-if="selected.includes(item)" class="far fa-fw fa-eye"></i>
							<i v-if="!selected.includes(item)" class="far fa-fw fa-eye-slash"></i>
						</td>
						<td>
							<div v-if="!is_dropped" class="form__field">
								<div class="form__label">
									<div v-if="!is_dropped" class="form__field">
										<div class="form__label">
											<VSwatches v-model="item.color"
												popover-x="bottom"
												swatches="text-advanced"
												title="Clique aqui para mudar a cor da rota"
												@input="edit_journey_color(index)"
												ref="input_color"
											/>
										</div>
									</div>
								</div>
							</div>
							<div v-else class="dropped-color"></div>
						</td>
						<td v-for="(header, index) in headers" :key="index" v-html="item_modified(item[index], index, item)"></td>
						<td v-if="!is_dropped && select_driver">
							<select v-model="item.driverDocument" ref="driverDocument" :disabled="finished">
								<option value="" :selected="item.driverDocument == ''">Não definido</option>
								<option v-for="(driver, indexDriver) in select_driver" :key="indexDriver" :value="driver.document" :selected="item.driverDocument == driver.document">
									{{driver.name.toUpperCase()}} - {{driver.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")}}
								</option>
							</select>
						</td>
						<td v-if="!is_dropped && has_options">
							<button class="button-show" @click="set_current_journey(item, index)" title="Ver rota" style="margin-right: 5px;">
								<i class="fa fa-route"></i> ROTA
							</button>
							<button v-if="!$parent.finished" class="button-show" :class="!permission ? 'button-disabled' : ''"  @click="edit_journey(item, index, true)" title="Editar entregas" style="margin-right: 5px;" :disabled="!permission">
								<i class="fa fa-boxes"></i> ENTREGAS
							</button>
							<button v-if="!$parent.finished" class="button-show" :class="!permission ? 'button-disabled' : ''"  @click="sequence_journey(item, index)" title="Editar sequência" style="margin-right: 5px;" :disabled="!permission">
								<i class="fa fa-exchange-alt fa-rotate-90"></i> SEQUÊNCIA
							</button>
							<button v-if="!$parent.finished" class="button-show" @click="show_edit_journey_color(index)" title="Editar cor da rota" style="margin-right: 5px;">
								<i class="fa fa-tint"></i> COR
							</button>
						</td>
					</tr>
					<tr v-for="(item, index) in list2" :key="'register2_' + index" class="disabled">
						<td>
							<i class="far fa-fw fa-eye-slash"></i>
						</td>
						<td></td>
						<td v-for="(header, index) in headers" :key="index" v-html="item_modified_2(item[index], index, item)"></td>
						<td v-if="select_driver"></td>
						<td v-if="has_options">
							<button v-if="!$parent.finished" class="button-show button-disabled" title="Ver rota" style="margin-right: 5px;">
								<i class="fa fa-route"></i> ROTA
							</button>
							<button  v-if="!$parent.finished" class="button-show" :class="!permission ? 'button-disabled' : ''" @click="edit_journey(item, index, false)" title="Editar entregas" style="margin-right: 5px;" :disabled="!permission">
								<i class="fa fa-boxes"></i> ENTREGAS
							</button>
							<button v-if="!$parent.finished" class="button-show button-disabled" :class="!permission ? 'button-disabled' : ''" title="Editar sequência" style="margin-right: 5px;" :disabled="!permission">
								<i class="fa fa-exchange-alt fa-rotate-90"></i> SEQUÊNCIA
							</button>
							<button v-if="!$parent.finished" class="button-show button-disabled" title="Editar cor da rota" style="margin-right: 5px;">
								<i class="fa fa-tint"></i> COR
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import VSwatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.css";

export default {
	name: "RoutingTableSummary",

	props: ["loading", "headers", "list", "list2", "modifiers", "modifiers2", "select_all", "on_select", "selected", "set_current_journey", "edit_journey", "edit_journey_color", "select_driver", "has_options", "is_dropped", "sequence_journey", "finished", "permission"],

	components: {
		VSwatches,
	},

	data: function() {
		return {
			color: "#000",
		};
	},
	
	computed: {
		colspan: function() {
			let i = Object.keys(this.headers).length + 2;
			if (this.on_select !== undefined) i++;
			return i;
		},
	},

	methods: {
		item_modified: function(value, index, item) {
			if (this.modifiers && this.modifiers[index] != undefined) {
				return this.modifiers[index](value, item);
			}
			return value;
		},
		
		item_modified_2: function(value, index, item) {
			if (this.modifiers2 && this.modifiers2[index] != undefined) {
				return this.modifiers2[index](value, item);
			}
			return value;
		},

		update: function() {
			// Atualiza Dom
			this.$forceUpdate();
		},

		show_edit_journey_color: function(index) {
			this.$refs.input_color[index].showPopover();
		},
	},
}
</script>

<style scoped>
.table-wrapper {
	width: 100%;
	/*max-height: 350px;
	overflow-y: auto;*/
}

.table {
	width: 100%;
	background: #fff;
}

.table th, .table td {
	text-align: left;
	padding: 10px;
	border-top: 1px solid #f0f0f0;
	font-size: 12px;
}

tbody tr:hover {
	background-color: #f0f0f0;
}

/*tr.disabled {
	color: #aaa;
}*/

.pointered {
    cursor: pointer;
}

.text-center {
	text-align: center;
}

.list-point-total {
	padding: 0px 5px;
	color: #fff;
}

.button-show {
    background: #222;
    border: none;
    color: #fff;
    font-weight: bold;
    font-size: 10px;
    padding: 5px 15px;
}

.button-disabled {
	background-color: #a0a0a0;
	cursor: not-allowed;
}

select {
	width: 100%;
}

.dropped-color {
	width: 14px;
	height: 14px;
	border: 4px solid #888;
	border-top-left-radius:15px;
	border-top-right-radius:15px;
	background-color: #fff;
	border-bottom-left-radius:15px;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);
	margin-top: -4px;transform: rotate(45deg);
}
</style>